import styled from 'styled-components'
import { Text } from '../../components/Text'
import { STYLES } from '../../static/style'

const SchoolChartTitle = styled(Text)`
  display: block;
  text-align: center;
  margin: 0.25rem 0;
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
`

export { SchoolChartTitle }
